<template>
	<div class="p-5 pb-5">
		<h2>Публичная оферта по предоставлению услуг Биржей
			«FASTSMM.RU».</h2>

		ИП Каляев В. А. (ИНН 272116395217, ОГРНИП 314231205800039)
		(именуемый в дальнейшем «Администрация»)
		предоставляет Пользователям услуги
		Биржи в соответствии с настоящими
		условиями, которые именуются «Правилами
		предоставления услуг Биржей «FASTSMM.RU»
		(далее «Правила»). Настоящие Правила в
		соответствии со смыслом, определяемым
		ст.ст. 437, 438 Гражданского кодекса РФ,
		являются публичной офертой.


		<h3>Раздел
			<span lang="en-US">I</span>. Термины и определения,
			используемые в настоящих Правилах
		</h3>

		<ol>
			<li>

				«FASTSMM.RU»
				– публичный сайт в сети «Интернет»
				(далее «Биржа» или «Сайт»), выступающий
				площадкой для Пользователей по вопросам
				выполнения работ и / или оказания услуг.
				Биржа на условиях настоящей оферты
				предоставляет Заказчикам возможность
				размещать заказы (далее «Задания») на
				выполнение работ и / или оказание услуг,
				в соответствии с определенными Заказчиком
				требованиями, а Исполнителям возможность
				принятия размещенных заданий для
				исполнения в порядке и на условиях,
				определяемых Заказчиком, либо по
				согласованию между Заказчиком и
				Исполнителем.

			</li>

			<li>

				«Аккаунт»
				– уникальная идентифицирующая Заказчика
				или Исполнителя страница, которая
				содержит информацию о Заказчике или
				Исполнителе, в том числе его платёжные
				реквизиты, статистические данные,
				баланс и движение денежных средств и
				другие необходимые данные.

			</li>
			<li>
				«Пользователь»
				– пользователь сети «Интернет», в
				частности, выразивший согласие с
				условиями настоящих Правил. Согласие
				с положениями настоящих Правил
				Пользователь выражает при регистрации
				на Сайте.
			</li>
			<li>
				«Заказчик»
				(«Рекламодатель») – Пользователь,
				публикующий задание на Сайте.
			</li>
			<li>


				«Исполнитель»
				– Пользователь, принимающий к исполнению
				задание, размещённое Заказчиком на
				Сайте, и предоставляющий Заказчику
				результаты выполненной работы.


			</li>
			<li>


				«Реферал»
				– Пользователь, привлеченный на Биржу
				другим Пользователем, путем совершения
				регистрации по предоставленной
				(реферальной) ссылке.


			</li>
			<li>


				«Рефер»
				– Пользователь, привлекающий иных лиц,
				не зарегистрированных на Сайте, путем
				предоставления им реферальной ссылки
				для последующей регистрации.


			</li>
			<li>


				«Учетная
				информация» – уникальные Логин и Пароль
				для входа на Сайт, указываемые
				Пользователем при регистрации на Сайте
				и хранимые в недоступном для третьих
				лиц месте.


			</li>
			<li>


				«Авторизация
				на Сайте» – получение доступа к аккаунту
				путём ввода учетной информации на
				Сайте.


			</li>
			<li>


				«Блокировка
				действий Пользователя» («Бан») –
				действия Администрации Сайта, запрещающие
				Пользователю доступ к аккаунту и
				совершение каких-либо действий с
				аккаунтом.
			</li>

		</ol>

		<h3>Раздел
			<span lang="en-US">II</span>. Общие положения Правил
		</h3>

		<ol>
			<li>
				При
				регистрации на Сайте Пользователь
				обязан ознакомиться со всеми положениями
				настоящих Правил. При нажатии кнопки
				«Регистрация» Пользователь
				подтверждает свое согласие с настоящими
				Правилами.


			</li>
			<li>


				Пользователи
				уведомлены о том, что актуальная редакция
				настоящих Правил расположена по
				следующей



				ссылке: https://wp.fastsmm.ru/#/rules .




				За Администрацией Сайта закреплено
				право на внесение изменений в настоящие
				Правила в одностороннем порядке, при
				этом они считаются вступившими в силу
				в момент их размещения по следующей




				ссылке: https://wp.fastsmm.ru/#/rules .

			</li>
			<li>


				Пользователи
				самостоятельно осуществляют отслеживание
				внесенных изменений в Правила. Отсутствие
				возражений со стороны Пользователя,
				выраженных в форме прекращения
				использования Сайта и / или удаления
				аккаунта, предполагает согласие
				Пользователя с внесенными изменениями.


			</li>
			<li>


				Все
				правила, не упомянутые в данной публичной
				оферте, но опубликованные от имени
				Администрации на Сайте, являются
				обязательными для всех Пользователей
				и представляют собой часть настоящей
				публичной оферты.


			</li>
			<li>


				За
				Администрацией Сайта закреплено право
				на удаление аккаунта Пользователя в
				случае отсутствия активности в аккаунте
				на протяжении шестимесячного периода.
				В указанном случае Пользователь теряет
				права требования на выплату оставшихся
				на балансе средств, а также всех
				закрепленных за Пользователем рефералов.


			</li>
			<li>


				В
				обязанности Администрации не входит
				обучение Пользователей Сайта работе
				с программами, необходимыми при
				взаимодействии с Биржей, а также
				необходимыми для создания заданий и /
				или работой над их выполнением.


			</li>
			<li>


				О
				любых ошибках / уязвимостях / способах
				обхода настоящих Правил / способах
				накрутки рейтинга / способах неправомерного
				увеличения средств на балансе аккаунта
				(далее «Баги») и злоупотреблениях ими
				Пользователь обязан сообщать Администрации
				Биржи. Запрещается прибегать к
				использованию вышеназванных багов в
				целях личного обогащения или улучшения
				свойств аккаунта, обогащения или
				улучшения свойств аккаунта третьих
				лиц, с целью навредить Администрации
				Биржи или другим Пользователям.


			</li>
			<li>


				Администрация
				Биржи (в лице Модераторов и их помощников)
				вправе ограничить авторизацию
				Пользователя на Бирже или ограничить
				доступ к любому из её разделов / сервисов.
				Объяснение причин ограничения доступа
				остается на усмотрение Администрации
				Биржи.


			</li>
			<li>


				Администрация
				Биржи (в лице Модераторов и иных,
				определенных Администрацией лиц) вправе
				исключить размещение любых материалов
				и заданий, если посчитает их нарушающими
				настоящие Правила, права третьих лиц
				или действующее законодательство.
				Объяснение причин удаления остается
				на усмотрение Администрации Биржи.


			</li>
			<li>


				Мерами
				взыскания за нарушение настоящих Правил
				являются: предупреждение, штраф,
				временное ограничение в пользовании
				Биржей, бессрочный бан аккаунта.
				Взыскание, наложенное Администрацией,
				обжалованию не подлежит.


			</li>
			<li>


				Решение
				о наложении любого вида взыскания и
				его виде, а также об отсутствии оснований
				для его наложения принимается
				Администрацией Биржи без участия
				Пользователей и третьих лиц.


			</li>
			<li>


				Способы
				принятия решения о наложении взыскания,
				методы выявления нарушителей,
				обстоятельства при которых было
				совершено и выявлено нарушение – не
				раскрываются Администрацией Биржи в
				целях предотвращения дальнейших
				нарушений, совершенных подобными
				способами.


			</li>
			<li>


				Бессрочный
				бан Аккаунта, помимо невозможности
				доступа к аккаунту, влечет за собой
				блокировку денежных средств на балансе
				и приостановление действий всех заданий.
				Все понесенные в результате бана убытки
				Администрацией Биржи не возмещаются.


			</li>
			<li>


				Комиссии
				на Сайте за вывод / ввод денежных средств
				на баланс аккаунта оплачиваются
				Пользователем.


			</li>
			<li>


				В
				случае нежелания иметь доступ и
				использовать услуги Биржи Пользователь
				вправе самостоятельно удалить свой
				аккаунт.


			</li>
			<!--<li>
				При
				регистрации, если не указано иное,
				Пользователь выражает согласие с
				возможностью получения информационных
				рассылок Биржи (в том числе с сообщениями
				о технических изменениях и неполадках,
				а также с рекламными сообщениями) на
				адрес электронной почты и и/ или иные
				контактные данные, оставленные
				Пользователем. Отказ от получения
				информационных рассылок возможен путем
				изменения настроек в аккаунте, а также
				путем перехода по ссылке «Отписаться
				от рассылки» в поступившем сообщении.
			</li>-->
			<li>


				Официальный
				язык Биржи – русский. Размещенные на
				Бирже задания должны быть на русском
				языке. Общение между Пользователями
				может происходить на любом другом языке
				по договоренности между сторонами.


			</li>
			<!--<li>
				Чтобы
				иметь возможность выводить денежные
				средства с баланса Аккаунта Пользователь
				должен быть верифицированным. Верификация
				происходит путем подтверждения
				указанного в Аккаунте номера телефона.
			</li>-->

		</ol>
		<br />
		<br />




		<h3>Раздел
			<span lang="en-US">III</span>. Обязанности пользователей
			Биржи
		</h3>


		<ol>

			<li>


				Предоставлять
				о себе подлинную информацию при
				заполнении полей профиля. В случае
				предоставления ложных сведений
				Администрация Биржи оставляет за собой
				право на бан аккаунта.


			</li>
			<li>


				Общение
				с Администрацией Биржи происходит на
				странице 'Помощь'.


			</li>
			<li>


				Пользователям
				в общении друг с другом, с Администрацией,
				а также в любых разделах Биржи запрещено
				публиковать сообщения и задания,
				содержащие «спам», оскорбления и
				непристойную лексику, в том числе в
				форме шуток, а также информацию и
				материалы эротического, порнографического
				и непристойного характера, информацию
				и материалы, разжигающие ненависть по
				религиозным, этническим и иным признакам,
				пропагандирующие насилие, вражду,
				ненависть по отношению к третьим лицам.
				Также запрещается использовать ресурсы
				и сервисы Биржи в целях попрошайничества,
				рассылать Пользователям и Администрации
				сообщения, содержащие угрозы,
				вымогательства, с призывами к совершению
				противоправных действий и иные,
				запрещенные законодательством действия.


			</li>
			<li>


				В
				случае, если в своем обращении Пользователь
				использует перечисленные в пункте 5
				раздела 3 настоящих Правил материалы,
				то Администрация Биржи оставляет за
				собой право не отвечать на такие
				обращения.


			</li>
			<li>


				Пользователи
				несут всю полноту ответственности (в
				том числе гражданской, административной
				и уголовной) за содержание тех сообщений
				и / или заданий, которые они рассылают
				и создают. При этом Администрация Биржи
				вправе применять по отношению к
				Пользователям, рассылающим сообщения
				и публикующим материалы, прямо
				противоречащие п. 3 раздела 3 настоящих
				Правил, меры взыскания, перечисленные
				в п. 10 раздела 2 Правил, а также удалять
				такие сообщения и материалы. Администрация
				реагирует на нарушения по мере поступления
				жалоб и снимает с себя ответственность
				за сообщения и материалы, нарушающие
				действующее законодательство. В
				остальных ситуациях Администрация не
				вмешивается в переписку между
				Пользователями.


			</li>
			<li>


				Пользователи
				согласны с тем, что Администрация Биржи
				в лице её уполномоченных сотрудников
				имеет право получить доступ к переписке
				между Пользователями в случае поступления
				жалобы на нарушение положений настоящих
				Правил.


			</li>
			<li>


				Регистрация
				двух и более аккаунтов одним Пользователем,
				а также регистрация с использованием
				одинаковых идентификационных данных
				(в том числе платежных реквизитов)
				категорически запрещена. В случае
				выявления и установления факта
				регистрации нескольких аккаунтов,
				принадлежащих и / или используемых
				одним Пользователем, и / или
				зарегистрированных на одинаковые
				идентификационные данные, на все
				обнаруженные аккаунты будет наложен
				бан со всеми последствиями, перечисленными
				в п.13 раздела 2 Правил.


			</li>
			<li>


				Регистрация
				нового аккаунта с использованием
				идентификационных данных аккаунта на
				который ранее был наложен бан за
				нарушение настоящих Правил запрещена.
				На такие аккаунты будет наложен бан со
				всеми последствиями, перечисленными
				в п.13 раздела 2 Правил.


			</li>
			<li>


				Пользователям
				запрещается использование «автокликеров»,
				«ускорителей таймеров» и иных программ,
				нарушающих Правила, а также программ,
				получающих доступ к аккаунту Пользователя.


			</li>
			<li>


				В
				случае поступления жалобы со сторонних
				ресурсов и сайтов на спам-рассылку
				реферальных ссылок от Пользователей
				настоящего Сайта, на аккаунты таких
				пользователей может быть наложен бан.


			</li>
			<li>


				Продажа,
				передача в пользование, дарение и иное
				отчуждение в пользу третьих лиц аккаунтов
				запрещена. Ответственность за сохранение
				учетной информации лежит на Пользователе.
				В случае несанкционированного доступа
				к аккаунту по вине Пользователя,
				Администрация не несет ответственность
				за возникшие убытки.


			</li>
			<!--<li>


				Изменение
				платежных и информационных данных
				Пользователя возможна только в
				интерфейсе, предоставляемом настоящей
				Биржей.


			</li>-->
			<li>


				Использование
				сервисов и разделов Биржи допускается
				только по прямому назначению, с учетом
				соответствующих описаний на самой
				Бирже или в её разделе. Иное использование
				запрещено.


			</li>
			<li>


				Биржа
				не обладает функциями и статусом
				платежного сервиса, обменного пункта.
				Прямая передача денежных средств
				Пользователями напрямую друг другу
				запрещена. При установлении факта
				прямой передачи денежных средств может
				повлечь за собой взыскания, перечисленные
				в п.10 раздела 2 настоящих Правил.


			</li>
			<li>


				Публикация
				результатов выполненных работ и / или
				готовых отчетов, в том числе при отклике
				на задание, или передача их другим
				Пользователям (за исключением Заказчика)
				запрещена. Настоящий запрет не касается
				действий самих Заказчиков при публикации
				ими заданий.


			</li>
			<li>


				Пользователи,
				отправляющие ложные отчеты или отчеты,
				вводящие в заблуждение Заказчика, могут
				быть подвергнуты бану. Администрация
				Биржи в целях улучшения качества сервиса
				предоставляемых услуг вправе периодически
				осуществлять проверку отчетов
				Пользователей в целях предотвращения
				недобросовестной практики по
				предоставлению ложных отчетов.


			</li>
			<li>


				Действия
				Пользователей, направленные на причинение
				прямого (имущественного или финансового)
				или косвенного (в том числе репутационного
				и распространяющего ложные сведения)
				ущерба Бирже или Пользователям Биржи
				запрещены.


			</li>
			<li>


				Если
				иное прямо не предусмотрено условиями
				Биржи, оказание услуг Заказчику на
				Бирже – приватная информация о Заказчике,
				распространение и разглашение которой
				третьим лицам может повлечь за собой
				бан аккаунта.
			</li>

		</ol>
		<br />
		<br />




		<h3>Раздел
			<span lang="en-US">IV</span>. Обязанности заказчиков
			Биржи
		</h3>


		<ol>

			<li>


				Заказчики
				несут всю полноту ответственности (в
				том числе гражданской, административной
				и уголовной) за содержание публикуемых
				заданий и материалов, используемых при
				публикациях. Администрация снимает с
				себя ответственность за ущерб, причиненный
				неправильно выполненным заданием.


			</li>
			<li>


				Запрещается
				создание заданий, выполнение которых
				связано с:
			</li>

		</ol>
		<ul class="ms-3">
			<li>
				посещением
				зараженных вирусами ресурсов, сайтов
				с фишинговыми ссылками;


			</li>
			<li>
				установкой
				программного обеспечения, нарушающего
				действующее законодательство, а также
				заражающее компьютеры пользователей
				и иным образом вредящее им;


			</li>
			<li>
				оказанием
				услуг по разработке и предоставлению
				доступа к программному обеспечению для
				взлома сайтов, воровства пользовательских
				данных, а также с посещением ресурсов
				на хакерские тематики;


			</li>
			<li>
				участием
				в откровенных и неприкрытых мошеннических
				действиях;


			</li>
			<li>
				просмотром
				и посещением ресурсов эротического,
				порнографического характера, а также
				связанных с показом такого рода
				материалов;


			</li>
			<li>
				посещением
				«интим»-сайтов, сайтов знакомств для
				секса и пр.;


			</li>
			<li>
				призывом
				к насилию, свержению власти, дискриминации
				по религиозному, половому, национальному
				и иным признакам, совершению противоправных
				действий;


			</li>
			<li>
				посещением
				ресурсов, маскирующихся под благотворительную
				деятельность;


			</li>
			<li>
				посещением
				сайтов, способствующих нарушению
				деятельности Биржи и / или отдельных ее
				частей и сервисов;


			</li>
			<li>
				посещением
				неоптимизированных сайтов, перегруженных
				рекламой, в том числе в виде всплывающих
				окон, а также содержащих объемный с
				точки зрения трафика контент;


			</li>
			<li>
				нарушением
				законов РФ.
			</li>

		</ul>


		<ol start="3">

			<li>


				Если
				созданное задание не содержит признаков,
				предусмотренных в п.2 раздела 4 настоящих
				Правил, однако потенциально способно
				нанести вред Пользователям или Бирже
				(как прямой, так и косвенный), то
				Администрация Биржи оставляет за собой
				право на запрет размещения заказа на
				Бирже как для отдельного Заказчика,
				там и любому Пользователю Биржи.


			</li>
			<li>


				Повторная
				попытка размещения задания, отклоненного
				в соответствии с п.3 раздела 4 Правил,
				на аккаунт Заказчика может быть наложен
				бан.


			</li>
			<li>


				Заказчик
				по требованию Администрации обязан в
				течение 3 (трех) дней предоставить
				разрешительную документацию (в том
				числе сертификат безопасности, лицензии
				и иные) на товары и услуги, на которые
				в соответствии с действующим
				законодательством существуют ограничения.


			</li>
			<li>


				Запрещено
				размещение заданий от имени Администрации,
				либо от имени других Пользователей, а
				также введение в заблуждение Исполнителей
				в части выполнения и получения
				вознаграждения за задание.


			</li>
			<li>


				Заказчик
				обязан регулярно проверять отчеты о
				выполненных оплачиваемых заданиях от
				Исполнителей. Проверка присланных
				отчетов осуществляется в панели
				Рекламодателя. Отправка на доработку
				или отказ в оплате выполненного задания
				должны быть мотивированы со ссылкой
				на пункт условий выполняемого задания.
				Немотивированные отказы и отправления
				на доработку, а также отказы и отправления
				на доработку, мотивированные ложными
				сведениями могут повлечь за собой
				наложение бана на аккаунт Заказчика.


			</li>
			<li>


				Заказчик
				обязан просмотреть и вынести вердикт
				по отчету Исполнителя в течение указанного при создании
				задания времени но не более 3 суток. В противном случае задание будет
				считаться выполненным, а денежные
				средства перечислены Исполнителю.


			</li>
			<li>


				Запрещено
				создание заданий:
			</li>

		</ol>
		<ul class="ms-3">
			<li>
				выполнение
				которых связано с отправкой СМС-сообщений
				или иными оплатами, стоимость которых
				явно превышает вознаграждение;


			</li>
			<li>
				обязывающих
				Исполнителя предоставить учетные данные
				аккаунта, а также иные идентифицирующие
				Пользователя данные, в том числе паспорт
				и иные документы;


			</li>
			<li>
				с
				указанием некорректных настроек, которые
				влекут нарушение работы Биржи или
				невозможность автоматической оплаты;


			</li>
			<li>
				условия
				которых заведомо либо в установленный
				в задании срок невыполнимы;


			</li>
			<li>
				проверка
				и оплата которых будет происходить вне
				Биржи;


			</li>
			<li>
				одновременно
				одинаковых по условиям выполнения;


			</li>
			<li>
				требующих:
				очернения других Пользователей, Биржи,
				интернет ресурсов, сайтов; оформления
				негативных реакций: комментариев и
				оценок; создания жалоб, оскорблений,
				преследований и угроз;


			</li>
			<li>
				связанных
				с возникновением у Исполнителя долговых
				и иных финансовых обязательств, таких
				как открытие счета, вклада, карты и пр.;


			</li>
			<li>
				условия
				которых требуют перевод денежных средств
				напрямую от Исполнителя Заказчику с
				использованием любых сторонних платежных
				сервисов, за исключением бонусных
				баллов, купонов, скидок, криптовалют и
				пр.;


			</li>
			<li>
				для
				конкретного или конкретных Исполнителей;
			</li>
			<li>
				с
				содержанием политической рекламы,
				голосований, опросов, пропаганды;

			</li>
			<li>
				направленные
				на нецелевое расходование средств
				рекламных кампаний
				<span lang="en-US">Google</span>
				<span lang="en-US">Ads</span>
				и Яндекс.Директ.
			</li>
		</ul>


		<ol start="10">

			<li>


				Категорически
				запрещается требовать от Исполнителей
				платежных реквизитов напрямую, а также
				информацию личного характера, такую
				как: отправленные на телефон сообщения,
				идентифицирующие Исполнителя данные,
				сканы паспортов и иных документов.


			</li>
			<li>


				Любое
				задание может быть приостановлено в
				любой момент времени для отправки на
				проверку соответствия настоящим
				Правилам. Проверка может занимать до
				7 (семи) рабочих дней, а в экстраординарных
				случаях продлена по решению Администрации.


			</li>
			<li>


				Заказчик
				создает задания, выполнение которых
				доступно всем Пользователям Биржи.


			</li>
			<li>


				Заказчик
				обязан полно и грамотно изложить задание
				и условия получения вознаграждения за
				его выполнение. Перенаправление
				пользователя с Биржи на другие ресурсы
				для ознакомления с заданием запрещено.
			</li>


		</ol>
		<br />
		<br />




		<h3>Раздел
			<span lang="en-US">V</span>. Финансовые отношения
			между Пользователями
		</h3>


		<ol>

			<li>


				Исполнитель
				вознаграждается в определенным
				Заказчиком размере за выполненное и
				принятое задание, путем зачисления
				денежных средств на баланс аккаунта.
				Вывод денежных средств возможен указанные платежные
				реквизиты.


			</li>
			<li>


				Пополнение
				баланса происходит путем создания
				заявки на пополнение счета. Сервис
				находится в личном кабинете Пользователя
				и позволяет перечислить денежные
				средства на платежных ресурсах, указанных
				в разделе «Пополнить счет.


			</li>
			<li>


				Вывод
				денежных средств на платежные реквизиты
				по выбору Пользователя может быть
				мгновенным (в автоматическом режиме)
				или с задержкой от 1 до 3 суток.


			</li>
			<li>


				Биржа
				не представляет интересы Заказчиков
				и Исполнителей, как следствие, не
				занимается регулированием финансовых
				взаимоотношений между Пользователями.
				Любые договоренности стороны осуществляют
				на свой страх и риск.
			</li>


		</ol>
		<br />
		<br />




		<h3>Раздел
			<span lang="en-US">VI</span>. Прочие условия настоящих
			Правил
		</h3>


		<ol>

			<li>


				Администрация
				Биржи не дает гарантий бесперебойного
				доступа к Бирже и ее сервисам. Форс-мажорные
				обстоятельства, а также действия
				злоумышленников могут нарушать
				функционирование Биржи. В этих случаях
				Администрация предпримет все возможное
				для скорейшего восстановления доступа
				к Бирже.


			</li>
			<li>


				Функционал
				Биржи позволяет Пользователям
				контактировать друг с другом и
				осуществлять расчеты за выполненные
				задания. При этом все возможные убытки,
				причиненные в результате взаимодействия
				между Пользователями, а также
				несоответствие результатов ожиданиям
				ложатся на самих Пользователей.


			</li>
			<li>


				Ответственность
				Администрации не распространяется на
				случаи причинения Пользователям убытков
				в результате взаимодействия друг с
				другом, потери учетных данных или утраты
				доступа к аккаунту, а также понесенные
				в связи с использованием функционала
				Биржи и ее сервисов или из-за невозможности
				использования таковых.


			</li>
			<li>


				Администрация
				не является гарантом по сделкам между
				Пользователями, не несет договорных
				обязательств перед сторонами, а также
				не участвует во взаимоотношениях
				сторон, не вмешивается в личные споры.


			</li>
			<li>


				Администрация
				сайта не отвечает за любой вид ущерба,
				причиненного действиями Пользователей
				Биржи друг другу и третьим лицам, как
				в ходе осуществления ими деятельности
				на самой Бирже, так и вне ее пределов.


			</li>
			<li>


				Любые
				неясности, спорные положения настоящих
				Правил требуют обращения Пользователя
				за разъяснением к Администрации. В
				случае отсутствия указаний по спорным
				ситуациям, они регулируются действием
				гражданского законодательства.
			</li>


		</ol>



		<a href="/#/register">Назад</a>
	</div>

</template>
 
<script>
import AppOptions from '../config/AppOptions.vue'


export default {

	data() {
		return {

		};
	},
	beforeRouteLeave(to, from, next) {
		AppOptions.appEmpty = false;
		next();
	},
	created() {
		if (!localStorage.getItem('user')) {
			AppOptions.appEmpty = true;
		} else {
			AppOptions.appEmpty = false;
		}
		this.siteName = process.env.VUE_APP_SITE_NAME

	},

}
</script>





